import { RadioQuestion } from "~/types/questionTypes"
import { redcapChoicesToRadioOptions } from "~/util/redcapChoicesToRadioOptions"
import Checkbox from "~/components/Checkbox"

type CheckboxFieldProps = {
  value: string | string[]
  question: RadioQuestion
  onChange: (newValue: string | string[]) => void
  className?: string
}

export const CheckboxField = (props: CheckboxFieldProps): JSX.Element => {
  const {
    question: { fieldName, selectChoicesOrCalculations },
    value,
    onChange,
    className
  } = props

  // Initialize as empty array if not set, or parse existing value
  const currentSelectedValues = value
    ? Array.isArray(value)
      ? value
      : [value]
    : []

  const optionsWithValues = redcapChoicesToRadioOptions(
    selectChoicesOrCalculations
  )

  return (
    <div className={`${className} flex flex-col gap-1.5`}>
      {optionsWithValues.map(({ label, value }) => (
        <div key={fieldName + value}>
          <Checkbox
            key={fieldName + value}
            name={fieldName}
            label={label}
            value={value}
            selectedValues={currentSelectedValues}
            onChange={onChange}
          />
        </div>
      ))}
    </div>
  )
}
